// Sort tab — mirrors MarketplacePricingTab shape + state handling.
// Controls grid sort: `host.activeSort` ∈ 'name' | 'priceAsc' | 'priceDesc'.

const LABELS = {
  name: 'Name',
  priceAsc: 'Price ↑',
  priceDesc: 'Price ↓'
}

export const MarketplaceSortTab = {
  extends: 'Button',
  padding: 'Y A',
  borderRadius: 'Z',
  background: (el, s) => s.activeSort === el.key ? 'blue' : 'transparent',
  color: (el, s) => s.activeSort === el.key ? 'white' : 'caption',
  fontWeight: (el, s) => s.activeSort === el.key ? '600' : '400',
  text: (el) => LABELS[el.key] || el.key,
  ':hover': { background: 'line' },

  onClick: (e, el, s) => {
    s.update({ activeSort: el.key })
    el.call('persistSort', el.key)
  }
}
